import Link from 'next/link';

const RecaptchaLegend = () => (
  <div className="flex justify-center my-20 font-thin">
    Este sitio está protegido por reCaptcha y la
    <Link href="https://policies.google.com/privacy" target="_blank" className="mx-2">
      Política de Privacidad
    </Link>
    y los
    <Link href="https://policies.google.com/terms" target="_blank" className="mx-2">
      Términos de Servicio
    </Link>
    de Google.
  </div>
);

export default RecaptchaLegend;
